import { getTiersProgram } from '@wix/ambassador-loyalty-v1-tier/http';
import { GetTiersProgramResponse } from '@wix/ambassador-loyalty-v1-tier/types';
import { ControllerFlowAPI, PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

export async function getLoyaltyTiersProgram(
  flowAPI: PlatformControllerFlowAPI | ControllerFlowAPI,
): Promise<GetTiersProgramResponse> {
  const { httpClient } = flowAPI;
  const { withErrorHandler, getResolvedError } = flowAPI.errorHandler;

  try {
    const response = await withErrorHandler(() => httpClient.request(getTiersProgram({})), {
      errorCodesMap: {},
    });

    return response.data!;
  } catch (error) {
    throw getResolvedError(error);
  }
}
